<template>
  <span :class="['bdc-label-icon-tag', `bdc-label-icon-tag--${variant}`]">
    <svg-icon :icon-class="iconMap[variant]" class="bdc-label-icon-tag__icon" />
    <span class="bdc-label-icon-tag__text"><slot /></span>
  </span>
</template>

<script>
const ICON_MAP = {
  white: 'bdc-icon-info',
  orange: 'bdc-icon-attention',
  red: 'bdc-icon-wrong',
  green: 'bdc-icon-success',
  main: 'bdc-icon-info',
  gray: 'bdc-icon-info'
}

export default {
  name: 'BdcIconTag',
  props: {
    variant: {
      type: String,
      default: 'gray',
      validator: (value) => ['white', 'orange', 'red', 'green', 'main', 'gray'].includes(value)
    }
  },
  computed: {
    iconMap() {
      return ICON_MAP
    }
  }
}
</script>
